import React, { useEffect, useState,lazy,Suspense } from "react";

//const Footer = React.lazy(() => import("../components/Footer/Footer"));
import Footer from "../components/Footer/Footer";
import dataServices from "../common/dataServices";

import ContactUs from "../components/contact/ContactUs";
//const ContactUs = React.lazy(() => import("../components/contact/ContactUs"));

 import "../components/Messages/Messages.css";
 //const Messages = React.lazy(()=>import("../components/Messages/Messages"));
 import Messages from "../components/Messages/Messages";
 //const PagesLinks = React.lazy(()=>import("../components/Messages/pagesLinks/pagesLinks"));
 import PagesLinks from "../components/Messages/pagesLinks/pagesLinks";
 
 //const UpdateRegistration  = React.lazy(()=>import("../components/contact/updateRegistration/UpdateRegistration"));
 import UpdateRegistration from "../components/contact/updateRegistration/UpdateRegistration";
 import UpdateRegistrationPage from "../components/contact/updateRegistration/UpdateRegistrationPage";
 
 //const Links = React.lazy(()=>import("../components/Links/Links"));
 import Links from "../components/Links/Links";

 //const Icons = React.lazy(()=>import("../components/Icons/Icons"));
 import Icons from "../components/Icons/Icons";
 //import CommonActions from "../components/CommonActions/CommonActions";
//import "./index.css";
import Grid from "../components/Grid/Grid";

const ModWebParts = (props) => {
  const [items, setItems] = useState(null);
  let type = props.webPartProperties.type;
  
  let webpartTitle = props.webPartProperties.title;
  
  let webpartLink = props.webPartProperties.readMoreLink;
  let webpartLinkTitle = props.webPartProperties.readMoreTitle;
  let webpartLayout = props.webPartProperties.layout;
  let freeText = props.webPartProperties.ModText;
  let WpId = props.webPartProperties.WpId;
  let siteUrl = props.webPartProperties.site;
  
  let loadSPList = !!props.webPartProperties.LoadSPList ?props.webPartProperties.LoadSPList==="True": true;
  
  useEffect(() => {
   
    //console.log(props.webPartProperties.listName);
    let listName = props.webPartProperties.listName;
    let viewName = props.webPartProperties.listView;
    
if (loadSPList)
{

    dataServices
      .getSPListItems(siteUrl, listName, viewName)
      .then((response) => response.data)
      .then((lsItemsResponse) => {
        try {
      
          setItems(lsItemsResponse.Data);
        } catch (e) {
          console.log(e);
        }
      });
    }
    else
    {
      setItems({});
    }
  }, []);
  

  if (items === null) {
    return null;
  }

  let selectedWP = "";
  
  switch (type) {
    case "ContactUs":
      
      if(webpartLayout.toLowerCase()=='first'){      
        // NewsLetter home page
        selectedWP = (
           <UpdateRegistration           
            mainURL={siteUrl}
            siteName={webpartLinkTitle}
            allPages={webpartLink}
            listName={props.webPartProperties.listName}           
           />
        );
      }
      else if (webpartLayout.toLowerCase()=='second'){
        selectedWP = (
                <ContactUs 
                  mainURL={siteUrl}
                  title={webpartLinkTitle}
                  link={webpartLink}
                  allPages={webpartLink}
                  listName={props.webPartProperties.listName}               
                />
              );
            }
            else if (webpartLayout.toLowerCase()=='third'){
            //news leteer page registration
              selectedWP = (
                <UpdateRegistrationPage           
                mainURL={siteUrl}
                title={webpartTitle}
                allPages={webpartLink}
                listName={props.webPartProperties.listName}           
               />
                    );
                  }
      break;
    
    case "Footer":
        
        selectedWP = <Footer items={items} />;
      break;
      case "Links":
     
          selectedWP = ( <Links allPages={webpartLink} title={webpartTitle} allMessagesLink={webpartLinkTitle} items={items}/>);
          break;
   
    case "Messages":
    //publications home page
       if(webpartLayout.toLowerCase()=='first'){
          selectedWP = (
            <Messages allPages={webpartLink} title={webpartTitle} allMessagesLink={webpartLinkTitle} items={items}/>
          );
       }
       //All News
       else if(webpartLayout.toLowerCase()=='second'){
        selectedWP = (
          <PagesLinks allPages={webpartLink} title={webpartTitle} allMessagesLink={webpartLinkTitle} items={items}/>
        );
       }
          break;
      case "Icons":
            selectedWP = (
              <Icons
                  items={items}
                  mainURL={siteUrl}
                  siteName={webpartLinkTitle}
                  title={webpartTitle} />
            );
      break;
      case "Grid":        
        selectedWP = <Grid items={items} 
        mainURL={siteUrl}
        siteName={webpartLinkTitle}
        title={webpartTitle}/>;
      break;
      default:
      break;
  }

  return (
    <div className={"modWPContainer " + type + "_" + webpartLayout}>
      {/* <Suspense fallback={<h3 role="alert"  >בטעינה ...</h3>}> */}
          {selectedWP}
      {/* </Suspense> */}
                     {/* <div title={webpartTitle} >                       
                         {selectedWP}
                    </div>  */}
    </div> 
  );
};
export default ModWebParts;
